import { GroupSecurity } from '@quromedical/fhir-common';
import { withPermissions } from 'components/groups';
import { LocationScreen } from 'screens/location';

export default withPermissions(LocationScreen, [GroupSecurity.LocationRead]);
